import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Chatbot from "@/components/Chatbot";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function MarketingLayout() {
  return (
    <div className="App relative bg-[#050A14] min-h-screen" data-testid="marketing-layout">
      <ScrollToTop />
      <Toaster position="top-center" theme="dark" richColors />
      <div className="noise-overlay" />
      <Navbar />
      <main className="relative">
        <Outlet />
      </main>
      <Chatbot />
    </div>
  );
}
